import React from "react";
import { twMerge } from "tailwind-merge";
import { useTranslation } from "react-i18next";

interface FormFieldsetProps {
  label: string;
  required?: boolean;
  children: React.ReactNode;
  className?: string;
}

export function FormFieldset({
  label,
  required = false,
  children,
  className = "",
}: FormFieldsetProps) {
  const { t } = useTranslation();
  return (
    <fieldset className={twMerge("fieldset text-base", className)}>
      <legend className="fieldset-legend text-base font-bold gap-1">
        {label} {required && <span className="text-primary uppercase">{t("system.required")}</span>}
      </legend>
      {children}
    </fieldset>
  );
}

export default FormFieldset;
